<template>
  <div class="index">
    <div class="index-ct">
      <button @click="handleClick">dddd</button>
      <!-- <div>{{ number_list }}</div> -->
    </div>
  </div>
</template>

<script>
  import { showSafeKeyboard } from '@/utils'
  export default {
    data() {
      return {
        number_list: [
          '62N1vJRKzHk0Dlh12kJUqA==',
          'a+9G3u0Bv6JOd93cqjtOqw==',
          'cxc6o2aNCpYjaoQsjDJlaQ==',
        ],
      }
    },
    methods: {
      handleClick() {
        showSafeKeyboard({
          type: '会员卡',
          config: undefined,
          onConfirm: v => {
            console.log(v)
          },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .index {
    padding: 20px;
    background-color: rgb(240, 242, 245);
    position: relative;
    height: calc(100vh - 100px);
    overflow: auto;
    &-ct {
      position: relative;
      min-height: calc(100vh - 140px);
      background-color: #ffffff;
      padding: 20px;
    }
  }
</style>
